import { Dialog } from "@mui/material";
import { useScale } from "common/utils";
import { getBodyFont } from "common/utils/font";
import { LevelClearIcon } from "features/courses/assets";

export const RecognitionRunSuccess = ({ reset: _reset }: { reset: () => void }) => {
  const { scale } = useScale();
  return (
    <Dialog
      open
      fullScreen
      componentsProps={{
        backdrop: { style: { backgroundColor: "transparent" } },
      }}
      sx={{ zIndex: 10001, backgroundColor: "transparent" }}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center !absolute w-full h-full bg-white/70">
        <div
          className="flex-col-center"
          style={{
            transform: `scale(${scale})`,
          }}
        >
          <div className="flex-col-center animate-fade-in">
            <div className="flex-col-view w-[696px] h-[264px] mb-[40px]">
              <LevelClearIcon />
            </div>

            <div className="flex-col-el flex-center">
              <svg width={608} height={80} viewBox="0 0 608 80">
                <text
                  x="50%"
                  y="20%"
                  textAnchor="middle"
                  dominantBaseline="central"
                  fill="#3F4A61"
                  fontSize="32"
                  fontFamily={getBodyFont()}
                  stroke="#FEFDFE"
                  strokeWidth={8}
                  paintOrder="stroke"
                >
                  {"おめでとう!このレベルをクリアしたよ!"}
                </text>
                <text
                  x="50%"
                  y="80%"
                  textAnchor="middle"
                  dominantBaseline="central"
                  fill="#3F4A61"
                  fontSize="32"
                  fontFamily={getBodyFont()}
                  stroke="#FEFDFE"
                  strokeWidth={8}
                  paintOrder="stroke"
                >
                  {"（スタート）を　はずしてください"}
                </text>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
